import React, {useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import {useTranslation} from 'react-i18next';
import * as Yup from "yup";
import {AddProductModel} from "../../containers/content/pages/recipe/model/AddProductModel";
import {BDSMForm} from "../form/BDSMForm";
import { PlusButton } from '../buttons/PlusButton';

const RecipeModal = ({onClick, product}) => {
    const [show, setShow] = useState(false);
    const {t} = useTranslation('recipe');
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const validation = Yup.object().shape({
        amountGross: Yup.number().required(t('validations:required'))
            .min(0.01, t('validations:higherThan') + 0.01),
        amountGrossCradle: Yup.number().required(t('validations:required'))
            .min(0.01, t('validations:higherThan') + 0.01),
        amountNet: Yup.number().required(t('validations:required'))
            .min(0.01, t('validations:higherThan') + 0.01),
        amountNetCradle: Yup.number().required(t('validations:required'))
            .min(0.01, t('validations:higherThan') + 0.01)
    });

    const handleSave = (values) => {
        onClick(product, values);
        handleClose();
    };

    const getFormModel = () => {
        return {
            initValues: AddProductModel.initModel,
            onSubmit: (record) => handleSave(record),
            onCancel: () => handleClose(),
            validationSchema: validation,
            fieldNames: AddProductModel.fieldNames,
            types: AddProductModel.fieldsTypes,
            className: 'mb-3',
            label: AddProductModel.fieldNames.map((it) => t(it)),
            selectData: AddProductModel.fieldNames.map(() => null),
            inputFieldsClass: ''
        }
    }

    return (
        <>
            <PlusButton disabled={product.id === -1} onClick={handleShow}></PlusButton>
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{product.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>{t('quantity')}</h4>
                    <BDSMForm form={getFormModel()}/>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default RecipeModal;
